import Layout from '@pbx/layouts/worksheet';

export const worksheet_crud = {
  path: '/pbx/worksheets',
  component: Layout,
  children: [
    {
      path: ':id([\\d]*)',
      name: 'pbx.worksheet.edit',
      component: () => import(/* webpackChunkName: 'pbx-worksheet' */ '@pbx/pages/worksheets/form'),
      meta: {
        loadable: true
      }
    }
  ]
};
